/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DowntimeType {
  Downtime = 'Downtime',
  Stopper = 'Stopper',
  Wash = 'Wash',
  SetupTime = 'SetupTime'
}
